export default function AttributionsPage() {
  return (
    <div
      className="pt-16"
      style={{
        backgroundImage: `url(https://static.igem.wiki/teams/4260/wiki/attributions/fondo-attributions.jpg)`,
        minHeight: "100vh",
      }}
    >
      <h1 className="text-6xl text-center text-white mt-10 font-bold">
        ATTRIBUTIONS
      </h1>
      <div
        className="p-10 mt-10 max-w-5xl m-auto text-white rounded-md"
        style={{ backgroundColor: "rgba(66, 138, 245,.7)" }}
      >
        <h2 className="text-5xl cano">General description</h2>
        <p className="p">
          <div align="justify">
            Here in attributions it is intended to acknowledge and appreciate
            enormously all the next people, institutions and organizations that
            have helped us to develop this project in the best possible way,
            either through their unconditional and financial support, as well as
            for providing advice, recommendations and their help in the
            laboratory. Without their help, this projects wouldn't have
            developed in the best way.
          </div>
        </p>
        <br></br>
      </div>

      <div
        className="p-10 mt-10 max-w-5xl m-auto text-white rounded-md"
        style={{ backgroundColor: "rgba(66, 138, 195,.7)" }}
      >
        <h2 className="text-5xl cano">Finance</h2>
        <p className="p">
          <div align="justify">
            In this section we want to acknowledge and give our gratitude to the
            next institutions and organizations for their financial support as
            well as for their sponsorship, because without their help, the
            development of this project wouldn't have been possible.
          </div>
        </p>
        <ul class="list-disc" style={{ marginLeft: "30px" }}>
          <li>
            <b>TEC</b>
          </li>
          <li>
            <b>Sponsorships</b>
          </li>

          <ul class="list-decimal" style={{ marginLeft: "20px" }}>
            <li>
              Instituto Tecnológico de Monterrey de Estudios Superiores CEM
            </li>
            <li>CTR</li>
            <li>Thermofisher</li>
            <li>Benchling</li>
            <li>Snapgene</li>
            <li>Beckman Coulter</li>
            <li>Our parents</li>
          </ul>
        </ul>
      </div>

      <div
        className="p-10 mt-10 max-w-5xl m-auto text-white rounded-md"
        style={{ backgroundColor: "rgba(136, 67, 204,.7)" }}
      >
        <h3 className="text-5xl cano">Support</h3>
        <p className="p">
          <div align="justify">
            iGem TecCEM gives thanks and acknowledgement to all the people and
            important institutions for helping in the development of this
            project. It is recognized by the great support by the Instituto
            Tecnológico de Monterrey de Estudios Superiores for the progress of
            this project and, in addition, we recognize the important support
            and advice of the attached people.
          </div>
        </p>
        <br></br>
        <p>
          <ul class="list-none" style={{ marginLeft: "30px" }}>
            <li>
              <b>a) Institutional</b>
            </li>
          </ul>
          <div align="justify">
            The institution and its representatives supported the project by
            providing and making available to the team the laboratories,
            equipment, and materials. It also contributed by covering the
            registration cost for the competition. In addition to providing
            highly trained teachers and staff who guide and lead us.
          </div>
          <ul class="list-disc" style={{ marginLeft: "40px" }}>
            <br></br>
            <li>
              <b>
                Instituto Tecnológico de Monterrey de Estudios Superiores CEM
              </b>
            </li>
            <div align="justify" style={{ marginLeft: "20px" }}>
              We would especially like to thank the director of the ITESM Campus
              Estado de México Verónica Pedrero and the Ph.D.. Andrés David
              García, director of School of Engineering and Science on the same
              campus, since they always gave us support and trust, believing in
              our abilities as professionals, researchers and students. Being
              the main supporting agents and promoters of this project year
              after year. Thank you!
            </div>
          </ul>
        </p>
        <br></br>
        <p>
          <ul class="list-none" style={{ marginLeft: "30px" }}>
            <li>
              <b>b) Project support and advice</b>
            </li>
          </ul>
          <div align="justify" style={{ marginLeft: "20px" }}>
            All those involved in advising and helping the project develop in
            the best way possible.
            <ul class="list-decimal" style={{ marginLeft: "30px" }}>
              <li>Ph.D.. María Guadalupe Pérez Loredo</li>
              <li>
                Ara Itzel De Los Santos Pérez Mondragón - advice on genetic
                engineering and protein issues.
              </li>
              <li>
                Cristian López Calleja - advice on genetic engineering and
                protein issues.
              </li>
              <li>
                Ph.D. Yolanda Guadalupe García Huante - advice on genetic
                engineering and protein issues.
              </li>
              <li>
                Ph.D. Alberto Ordaz Cortés - support in proposing experimental
                designing of enzymatic activity of laccase and advice for
                mathematical modeling
              </li>
              <li>
                Ph.D.. Elías Octavio Gómez - technical support with seeds culture in
                vitro
              </li>
              <li>
                Ph.D. Anaid Cano - advice and technical support on
                electrochemical deposition methods, building and
                characterization
              </li>
              <li>
                Ph.D. Lizbeth Melo Máximo - advice on nanoparticle protocol
                design
              </li>
              <li>
                Ph.D. José Erick Ortega Valencia - project validation and
                technical support
              </li>
              <li>
                Ph.D. Enrique Eliseo Minor Campa - advisory for modeling in
                Integrated Human Practices
              </li>
              <li>
                Ph.D.. Estrada-Arriaga Edson Baltazar with an interview and advice
                regarding endocrine disruptors in water treatment plants
              </li>
              <li>
                M.C. Luis Alberto López Juárez for his assessment regarding our
                Meetup classes
              </li>
              <li>
                Ph.D. Elvia Patricia Sánchez Rodríguez - Laboratory support for
                the management of the characterization equipment
              </li>
              <li>
                Diego Palmerín Bonada , Fernando Melgar and Michel Dionne for
                the valuable contribution to the wiki elaboration
              </li>
            </ul>
          </div>
        </p>
        <p>
          <br></br>
          <ul class="list-none" style={{ marginLeft: "30px" }}>
            <li>
              <b>c) Lab support</b>
            </li>
          </ul>
          <div align="justify" style={{ marginLeft: "20px" }}>
            Those involved in providing material of the best quality to develop
            this project.
            <ul class="list-decimal" style={{ marginLeft: "30px" }}>
              <li>
                Biol. Ramón Eduardo Rivero Aranda - advise and laboratory of
                biotechnology support for the team
              </li>
              <li>
                M. Roberto Delgado Durán - advise and laboratory of biotechnology
                support for the team
              </li>
              <li>Miguel Gómez Lim - contributed with Guaiacol reactant</li>
              <li>
                Javier Ulises Arreola Ortega - advise and laboratory of
                chemistry support for the team
              </li>
              <li>
                Ph.D.. María Guadalupe Pérez Loredo - advice, support and for helping
                the team in obtaining CBZ and reactants
              </li>
              <li>
                Andrea Arriola Gamboa - Support in the laboratory practices
              </li>
              <li>
                Adriana Romero Pérez - Support in the laboratory practices
              </li>
              <li>
                Official iGEM team members
              </li>
            </ul>
            <br></br>
            <ul class="list-disc" style={{ marginLeft: "30px" }}>
              <li>
                <b>For their laboratory support taking care of our lettuces twice a week:</b>
              </li>
              <ul class="list-none" style={{ marginLeft: "20px" }}>
                <li>- Silvana María Gressi Dávila</li>
                <li>- Axel Araujo Montaño</li>
                <li>- Tania García Santillán</li>
              </ul>
            </ul>
            <ul class="list-disc" style={{ marginLeft: "30px" }}>
              <li>
                <b>For their laboratory support helping with characterization:</b>
              </li>
              <ul class="list-none" style={{ marginLeft: "20px" }}>
                <li>- Rodrigo Uriel Escobedo García</li>
                <li>- Adrian Hernández Najera</li>
                </ul>
            </ul>
          </div>
        </p>
        <br></br>
        <p>
          <ul class="list-none" style={{ marginLeft: "30px" }}>
            <li>
              <b>d) General support</b>
            </li>
          </ul>
          <div align="justify" style={{ marginLeft: "20px" }}>
            Those involved contributed to the supervision of iGEM’s digital
            material.
            <ul class="list-disc" style={{ marginLeft: "30px" }}>
              <li>Roberto Alcántara - supervisor of social and digital</li>
              <li>Gabriel Jesús Martínez Lima - videos sound reinforcement</li>
              <li>
                Nayelhi Alcazar, Francisco Castañeda, Alejandro Mejorada,
                Rodrigo Valencia - feedback of the actual project
              </li>
              <li>
                Daniela Michelle Núñez Nerio - Helped in writing the binnacle of
                Safety Project in digital
              </li>
            </ul>
            <div align="justify" style={{ marginLeft: "20px" }}>
              Special thanks to all of our family members, friends, partners,
              school mates, pets and coffee cups for the patience, emotional and
              economical support.
            </div>
          </div>
        </p>

        <br></br>
        <p>
          <ul class="list-none" style={{ marginLeft: "30px" }}>
            <li>
              <b>e) Human Practices support</b>
            </li>
          </ul>
          <div align="justify" style={{ marginLeft: "20px" }}>
            Those who contributed with Human Practices linkage and coordination
            <ul class="list-disc" style={{ marginLeft: "30px" }}>
              <li>
                Fernando García Mora - linked the iGEM team with governmental
                institutions
              </li>
              <li>
                Planet Soldiers - coordination of activities of volunteering
              </li>
              <li>
                Botanic garden of Institute of Biology from UNAM - Divulgation
                platform of the project
              </li>
              <li>
                Salma Gómez Ibarra - leader of the podcast CIENCIANDO - Contact
                and support of divulgation of the project
              </li>
              <li>
                Said Kobeh - Biogranja los Tizones owner - advice and consulting
                for the Human Practices project
              </li>
              <li>
                Agronomist Engineer Oscar Garcia Diaz - provided valuable
                information and advice about agronomics
              </li>
              <li>
                Ana Brito - Director of the school “Xinaxtli”, who let us
                promote our project to her students
              </li>
              <li>
                Elementary school “Adolfo López Mateos” - let us promote our
                project to their students
              </li>
              <li>Julira Macías - Delegate of Mexico</li>
              <li>
                Gustavo Ruiz Galindo - Coordinator of advisors from the mexican
                political party “Movimiento Ciudadano”
              </li>
              <li>Mtra. Rosa Wolpert - National Education Officer at UNESCO</li>
              <li>
                Chuen Uac Zip - President at the Nacel Arcoiris association,
                helped in the reforestation
              </li>
              <li>Civil Community pro “Lago Espejo de los Lirios”</li>
              <li>
                President Juanita Kadala - Protector of Cultural and Natural
                patrimony, shelped in getting the contact of Chuen Uac Zip and
                transport sponsorship
              </li>
            </ul>
            <div align="justify" style={{ marginLeft: "20px" }}>
              Special thanks to all of our family members, friends, partners,
              school mates, pets and coffee cups for the patience, emotional and
              economical support.
            </div>
          </div>
        </p>
        <br></br>
        <p>
          <ul class="list-none" style={{ marginLeft: "30px" }}>
            <li>
              <b>f) Fundraising</b>
            </li>
          </ul>
          <div align="justify" style={{ marginLeft: "20px" }}>
            Those involved in helping the iGem TecCEM by providing financial
            support.
            <ul class="list-disc" style={{ marginLeft: "30px" }}>
              <li>Alberto de los Santos Cayetano - donor</li>
              <li>Patricia Orozco Leyva - donor</li>
              <li>Rigel Valentín Gómez Acata - donor</li>
              <li>María Guadalupe Pérez Loredo - donor</li>
              <li>Ma. Elena Pérez Trejo - donor</li>
              <li>Patricia Pérez Trejo - donor</li>
              <li>Alma Cecilia Belegui Castro Lugo - donor</li>
              <li>Óscar Martínez Valdés - donor</li>
              <li>Francisco Castañeda - donor</li>
              <li>Cecilia Martinez - donor</li>
              <li>Rodolfo Guerra Trejo - donor</li>
              <li>Bertha Verduzco Castañeda - donor</li>
              <li>Dulce M. Guerra Trejo - donor</li>
              <li>Ricardo Patiño Villegas - donor</li>
              <li>Maribel Juárez Rivera - donor</li>
              <li>Oliverio Juárez García - donor</li>
              <li>Inocencia Rivera Hernández - donor</li>
              <li>José Isidro Minero Alfaro - donor</li>
              <li>María L. Morales - donor</li>
              <li>Nadia Espinoza - donor</li>
              <li>Ana María López Carmona - donor</li>
              <li>José Minero Alfaro - donor</li>
              <li>María L. Morales - donor</li>
              <li>Francisco Castañeda - donor</li>
              <li>Cecilia Martinez - donor</li>
              <li>Leticia de los Santos Cayetano - donor</li>
              <li>Alessandro Medina Acosta - donor</li>
              <li>Ian Méndez Acacio - donor</li>
              <li>José Lozano - donor</li>
            </ul>
          </div>
        </p>
        <br></br>
        <p>
          <ul class="list-none" style={{ marginLeft: "30px" }}>
            <li>
              <b>g) Emotional</b>
            </li>
          </ul>
          <div align="justify" style={{ marginLeft: "20px" }}>
            Thank you for your willingness and to solve specific doubts in an
            efficient way, despite having little context about the project. We
            could not have been able to continue without your precise advice.
            <ul class="list-disc" style={{ marginLeft: "30px" }}>
              <li>Alonso Méndez Vera - emotional support</li>
              <li>Cynthia Nayeli Patiño Guerra - emotional support</li>
              <li>Shulinnen Odette Ramírez Soto - emotional support</li>
              <li>Axel Araujo Montaño - emotional support</li>
              <li>Roberto Sandoval Rivera - emotional support</li>
              <li>Gerardo Matus Gallardo - emotional support</li>
              <li>Fernando Pérez González - emotional support</li>
              <li>Valeria Jiménez López - emotional support</li>
              <li>Marlen Miranda Resendiz - emotional support</li>
              <li>Abril Peralta Luévano - emotional support</li>
              <li>Alexa Martínez Cervantes - emotional support</li>
              <li>Frida Sofía Ríos Escobar - emotional support</li>
              <li>Ximena García López - emotional support</li>
              <li>Anahí Alonso Juárez - emotional support</li>
              <li>Karina Juárez Rivera - emotional support</li>
              <li>Leonor Pérez Trejo - emotional support</li>
            </ul>
          </div>
        </p>
        <br></br>
      </div>
      <div
        className="p-10 mt-10 max-w-5xl m-auto text-white rounded-md"
        style={{ backgroundColor: "rgba(219, 159, 39,.7)" }}
      >
        <h2 className="text-5xl cano">Interviews</h2>
        <p className="p">
          <div align="justify">
            Those external to our institution who contributed to the development
            of the iGEM project by providing us with advisory and experimental
            advice according to their study field and experience.
          </div>
          <ul class="list-disc" style={{ marginLeft: "30px" }}>
            <li>Ph.D. Edson Baltazar Estrada</li>
            <li>Ph.D. Sergio Alberto Cortés Ramírez</li>
            <li>Ph.D. Mauricio Rodríguez Dorantes</li>
          </ul>
        </p>
        <br></br>
      </div>

      <div
        className="p-10 mt-10 max-w-5xl m-auto text-white rounded-md"
        style={{ backgroundColor: "rgba(245, 176, 66,.7)" }}
      >
        <h2 className="text-5xl cano">Judges Meetup</h2>
        <p className="p">
          <div align="justify">
            iGem TecCEM acknowledges all these people for participating in the
            best way for the Giant Jamboree simulation, as well for other
            important conferences, such as Dual Use and Molecular Docking.
          </div>
          <ul class="list-disc" style={{ marginLeft: "30px" }}>
            <li>Ph.D. Alberto Ordaz Cortés</li>
            <li>Ph.D. Aurora Antonio Pérez</li>
            <li>Ph.D. Ana Laura Torres Huerta</li>
            <li>Ph.D. César García Díaz</li>
            <li>José Garza Martínez</li>
            <li>David García Gómez</li>
            <li>Omar David Ríos Monjaraz</li>
          </ul>
        </p>
      </div>
    </div>
  );
}
